import { api } from '../client';

// Auth response types
export interface AuthUser {
  id: number;
  name: string;
  email: string;
  merchant_name?: string;
  user_type?: string;
  first_name?: string;
  last_name?: string;
  contact_number?: string;
  location_address?: string;
  /** Module keys the user can access (from role permissions). Null = show all (merchant/owner). */
  allowed_modules?: string[] | null;
}

export interface AuthResponse {
  access_token?: string;
  user?: AuthUser;
  message?: string;
  errors?: Record<string, string[]>;
}

export interface MeResponse {
  user?: AuthUser;
}

export const authApi = {
  async register(data: {
    merchantName: string;
    firstName: string;
    lastName: string;
    contactNumber: string;
    locationAddress: string;
    email: string;
    password: string;
    password_confirmation?: string;
    confirmPassword?: string;
  }): Promise<AuthResponse> {
    const payload = { ...data };
    if (payload.confirmPassword && !payload.password_confirmation) {
      payload.password_confirmation = payload.confirmPassword;
      delete payload.confirmPassword;
    }
    const res = (await api.post('/register', payload, false)) as AuthResponse;
    if (res.access_token) {
      localStorage.setItem('auth_token', res.access_token);
      if (res.user) localStorage.setItem('user_data', JSON.stringify(res.user));
    }
    return res;
  },

  async login(data: { email: string; password: string }): Promise<AuthResponse> {
    const res = (await api.post('/login', data, false)) as AuthResponse;
    if (res.access_token) {
      localStorage.setItem('auth_token', res.access_token);
      if (res.user) localStorage.setItem('user_data', JSON.stringify(res.user));
    }
    return res;
  },

  async logout() {
    const res = await api.post('/logout', {});
    localStorage.removeItem('auth_token');
    localStorage.removeItem('user_data');
    return res;
  },

  async me(): Promise<MeResponse> {
    return api.get('/me') as Promise<MeResponse>;
  },
};
